import React from 'react';

import { ContentComponent } from './ui/contentComponent';
import type { ConflictResolutionUIPlugin } from './conflictResolutionUIPluginType';

export const conflictResolutionUIPlugin: ConflictResolutionUIPlugin = ({ api, config }) => {
	return {
		name: 'conflictResolutionUI',
		contentComponent: () => {
			return <ContentComponent config={config} api={api} />;
		},
	};
};
